const plural = (n: number, one: string, many: string) => (n === 1 ? one : many);
const codes = (n: number) => `${n} ${plural(n, 'code', 'codes')}`;

/**
 * Counts of codes and permissions. "Active" always means Shopify accepts the
 * code at checkout right now; a number that also covers expired, scheduled or
 * turned-off codes is never called active.
 */
export const shopifyCountsCopy = {
  /** `total` comes off the wire; without it only the active count is known. */
  uninstallCodes: (total: unknown, active: number) => {
    if (typeof total !== 'number' || !Number.isFinite(total)) {
      return `${active} active ${plural(active, 'discount code', 'discount codes')}`;
    }
    const noun = plural(total, 'discount code', 'discount codes');
    const working = Math.min(active, total);
    if (total === 0) return 'No discount codes';
    if (working === total) return `${total} active ${noun}`;
    return `${total} ${noun} (${working === 0 ? 'none' : working} active)`;
  },
  editReachCampaign: (n: number) =>
    `This changes all ${n} tracked ${plural(n, 'code', 'codes')} on this campaign.`,
  editReachDiscount: (n: number) =>
    `This changes the ${n} tracked ${plural(n, 'code', 'codes')} on this discount.`,
  editNativeReach:
    'Every code on this Shopify discount shares these terms, including codes created or renamed directly in Shopify.',
  editReachOutside: (n: number) =>
    `The campaign’s other ${codes(n)} ${plural(n, 'sits', 'sit')} on a different discount and won’t change.`,
  editNotRedeemable: (state: 'scheduled' | 'expired') =>
    state === 'expired'
      ? 'This discount has ended in Shopify, so its codes don’t work right now.'
      : 'This discount hasn’t started in Shopify yet, so its codes don’t work right now.',
  permissionsHeading: (granted: number, requested: number) =>
    `Permissions (${granted} of ${requested} granted)`,
  alsoGrantedHeading: (n: number) => `Also granted (${n})`,
  alsoGrantedNote: 'Shopify adds these automatically with the permissions above.',
  readPixelsPurpose: 'Included automatically with Edit web pixels.',
  dangerZone: 'Danger zone',
};
